interface StorageItem {
  value: any;
  expiry: number;
}

/**
 * Stores a value in local storage with a time to live
 * @param key the key to store the value under in local storage
 * @param value any value to store in local storage, does not need to be strigified
 * @param ttlInMinutes the time to live in minutes, defaults to 60 minutes
 * @example setWithExpiry('myKey', {data: 'test'}, 60);
 */
export function setWithExpiry(key: string, value: any, ttlInMinutes: number = 60) {
  const now = new Date();

  const item: StorageItem = {
    value: value,
    expiry: now.getTime() + ttlInMinutes * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * fetches a value from local storage if it exists and is not expired
 * @param key the key to retrieve from local storage
 * @returns the value stored in local storage if it exists and is not expired, otherwise returns null
 * @example getWithExpiry('myKey')
 */
export function getWithExpiry<T>(key: string) {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item: StorageItem = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value as T;
}
